import { getHandleResponse } from "helpers/getHandleResponse";
import { getAuthHeader } from "helpers/getAuthHeader";

const API_BASE_URL = process.env.REACT_APP_URL;

const makeRequest = async (endpoint, method, data = null) => {
    const requestOptions = {
        method,
        headers: getAuthHeader(),
    };

    if (data) {
        requestOptions.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);
        const result = await getHandleResponse(response);
        return { error: false, data: result };
    } catch (error) {
        return { error: true, data: error.message };
    }
};

const authService = {
    // Rutas públicas
    login: (data) => makeRequest("/api/auth/login", "POST", data),
    register: (data) => makeRequest("/api/auth/register", "POST", data),
    forgotPassword: (email) => makeRequest("/api/auth/forgot-password", "POST", { email }),
    resetPassword: (data) => makeRequest("/api/auth/reset-password", "POST", data),

    // Rutas protegidas
    getProfile: () => makeRequest("/api/auth/profile", "GET"),
    updateProfile: (data) => makeRequest("/api/auth/profile", "PUT", data),
    changePassword: (data) => makeRequest("/api/auth/change-password", "POST", data),
    verifyToken: () => makeRequest("/api/auth/verify", "GET"),
    getUsers: (params = {}) => { const query = new URLSearchParams(params).toString();
        return makeRequest(`/api/auth/users${query ? `?${query}` : ""}`, "GET");
    },
    registerAdmin: (data) => makeRequest("/api/auth/register-admin", "POST", data),
    resetUserPassword: (userId) => makeRequest(`/api/auth/users/${userId}/reset-password`, "POST"),
    updateUser: (userId, data) => makeRequest(`/api/auth/users/${userId}`, "PUT", data),
};

export default authService;